module.exports = __webpack_public_path__ + "media/images/tasks_banner-e9993108.svg";